import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { DashboardLayout } from './DashboardLayout';
import { AlertTriangle } from 'lucide-react';

export const ModuleProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isRouteEnabled, loading } = useSubscription();

  // Show loading state while checking subscriptions
  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-96">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </DashboardLayout>
    );
  }

  // Check if the current route is enabled
  if (!isRouteEnabled(location.pathname)) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-[calc(100vh-200px)]" data-testid="module-access-denied">
          <div className="text-center max-w-md mx-auto p-8">
            <div className="flex justify-center mb-6">
              <div className="h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center">
                <AlertTriangle className="h-8 w-8 text-amber-600" />
              </div>
            </div>
            <h1 className="text-2xl font-semibold text-foreground mb-4">
              Module Not Available
            </h1>
            <p className="text-muted-foreground mb-6">
              Your organization has not subscribed to the requested module, please{' '}
              <Link 
                to="/dashboard" 
                className="text-primary hover:underline font-medium"
                data-testid="go-back-home-link"
              >
                click here
              </Link>
              {' '}to go back to home page.
            </p>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return children;
};
